import BaseAPI from './base.api';

export interface CustomerNotificationPreference {
  customerId: string;
  customerCode: string;
  customerName: string;
  tpmsAlertsEnabled: boolean;
}

export default class PushNotificationPreferenceAPI extends BaseAPI {
  async getAll(userId: string) {
    const response = await this.API.get('push-notification-preferences', {
      params: { userId },
    });

    return response.data;
  }

  async update(payload: {
    customerId: string;
    userId: string;
    tpmsAlertsEnabled: boolean;
  }) {
    const response = await this.API.patch(
      'push-notification/preference',
      payload
    );

    return response.data;
  }

  /** Every customer this admin manages, with the users under each and their TPMS preference. */
  async getManagedUsers(userId: string) {
    const response = await this.API.get(
      'push-notification-preferences/managed-users',
      {
        params: { userId },
      }
    );

    return response.data;
  }
}
